import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchModelVersion } from "#modules/models/infra/fetchModelVersion.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const modelVersionQuery = () => ({
  queryKey: queryKeys.models.mineVersion,
  queryFn: () => fetchModelVersion(),
  staleTime: STALE_TIME,
});
